import { businessProfileLinkPending } from 'lib/common/messages';
import addMessage from 'action-creators/messaging/add-message';

export default function linkBusinessProfilePending() {
  return addMessage(businessProfileLinkPending);
}
